import { inject, Pipe, PipeTransform, SecurityContext } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

// transforms a string containing [references] syntax to SafeHtml with links
@Pipe({
  name: 'link',
})
export class LinkPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);
  private regex = /\[(.*?)\]/g;

  transform(value: string | null | undefined, route: string): SafeHtml {
    if (!value) {
      return '';
    }

    let html = value;

    const matches = value.matchAll(this.regex);
    for (const match of matches) {
      const key = match[0];
      const value = match[1];

      // unfortunately, these links will not utilize angular router
      html = html.replaceAll(key, `<a href="${route}${value}">${value}</a>`);
    }

    return this.sanitizer.sanitize(SecurityContext.HTML, html) || '';
  }
}
